export enum ProfileStage {
    ProfileIncomplete = 'PROFILE_INCOMPLETE',
    BasicProfileSetup = 'BASIC_PROFILE_SETUP',
    ProfileCompleted = 'PROFILE_COMPLETED',
    ResumeParsingInProgress = 'RESUME_PARSING_IN_PROGRESS'
}

export enum AccountStatus {
    InActive = 'IN_ACTIVE',
    Active = 'ACTIVE',
    Disabled = 'DISABLED',
    Blocked = 'BLOCKED',
    InReview = 'IN_REVIEW',
}

export enum UserType {
    Mentor = 'MENTOR',
    Mentee = 'MENTEE',
}

export enum TokenType {
    Access = 'ACCESS',
    Refresh = 'REFRESH',
    Verify = 'VERIFY',
}

export enum WeekDay {
    Sun = 'SUN',
    Mon = 'MON',
    Tue = 'TUE',
    Wed = 'WED',
    Thu = 'THU',
    Fri = 'FRI',
    Sat = 'SAT',
}

export enum BlackoutStatus {
    Upcoming = 'UPCOMING',
    Completed = 'COMPLETED',
}

export enum OrderDirection {
    Asc = 'ASC',
    Desc = 'DESC',
}

export enum BlackoutOrderBy {
    Name = 'name',
    Date = 'date',
    CreatedAt = 'createdAt',
}

export enum SessionsTabType {
    UPCOMING = 'UPCOMING',
    PREVIOUS = 'PREVIOUS',
    CANCELLED = 'CANCELLED',
}

export enum StepperStatus {
    COMPLETE = 'COMPLETE',
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING = 'PENDING',
}

export enum NotificationStatus {
    READ = 'READ',
    UNDREAD = 'UNREAD',
}

export enum CalendarType {
    GOOGLE = 'GOOGLE',
    OUTLOOK = 'OUTLOOK',
    YAHOO = 'YAHOO',
}

export enum SessionCalenderView {
    MONTH = 'month',
    YEAR = 'year',
    DECADE = 'decade',
    CENTURY = 'century',
}

export enum GlobalConfigTypes {
    MinSessionsCompleted = "MIN_SESSIONS_COMPLETED",
    PaymentCycleInDays = "PAYMENT_CYCLE_IN_DAYS",
    SessionIntervalInMinutes = "SESSION_INTERVAL_IN_MINUTES",
    SessionCancelTimeoutInMinutes = "SESSION_CANCEL_TIMEOUT_IN_MINUTES",
    BankPayoutMode = "BANK_PAYOUT_MODE",
    BankPayoutAccountNumber = "BANK_PAYOUT_ACCOUNT_NUMBER",
    MenteePlanTimeoutInHours = "MENTEE_PLAN_TIMEOUT_IN_HOURS",
    SessionCompletedTimeoutInHours = "SESSION_COMPLETED_TIMEOUT_IN_HOURS",
    PaypalPayoutChargesPercentage = "PAYPAL_PAYOUT_CHARGES_PERCENTAGE",
    RazorpayPayoutChargesPercentage = "RAZORPAY_PAYOUT_CHARGES_PERCENTAGE",
    MaxPayoutFailureAttempts = "MAX_PAYOUT_FAILURE_ATTEMPTS",
    MenteePlanFailureTimeoutInMins = "MENTEE_PLAN_FAILURE_TIMEOUT_IN_MINS",
    SessionBasePrice = "SESSION_BASE_PRICE",
}